<div class="todo-app">
    <!-- <div class="jump" id="about"></div> -->

    <div class="list">
      I followed the <a target="_blank" href="https://ng-girls.gitbook.io/todo-list-tutorial/workshop-todo-list/workshop-todo-list">ngGirl's To-Do List App tutorial</a> and added my own flair. This tutorial breaks down how to:<br>
    <ul>
<li>initialize your Todo application using Angular CLI,</li>
<li>generate components to represent individual variables & methods,</li>
<li>utilize a Todo DataService for saving and managing tasks,</li>
<li>add appealing style to improve user interface, and</li>
<li>deploy your application to GitHub & StackBlitz.</li>
</ul>
</div>

<div class="info">
<!-- <br><br> -->
<p>I started coding in 2019 and love the organization of Angular! I have particpated in several <a target="_blank" href="https://twitter.com/AngularGirls">@AngularGirls</a> conferences and was a mentor for the first time for <a target="_blank" href="https://workshops.ng-girls.org/ngconf-2021/">ngConf 2021</a>!  When I am not coding, I am working on the farm, cooking in the kitchen, or spending time with family.
      <br>
      Let's Connect!

        <base target="_blank"/>
          <a href="mailto:jenhalv06@gmail.com" class="fa fa-envelope" aria-hidden="true" alt="envelope"></a>
          <a href="https://twitter.com/jennlynnhalv" class="fa fa-twitter" aria-hidden="true" alt="twitter"></a>
          <a href="https://www.linkedin.com/in/jennifer-halvorson-portfolio2020" class="fa fa-linkedin" aria-hidden="true" alt="linkedin"></a>
        </p>


    <div class="copyright">
      <div class="tooltip">
  <img alt="Jennifer Bitmoji" src="assets/Cat1.png"/>
  <span class="tooltiptext">I know, I know...another pic of my cat.</span></div>
  <p class="bottom"><span class="material-icons-outlined">copyright</span>
  Jennifer Halvorson 2021</p>
</div>
</div>
</div>



